import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import ClickAwayListener from '@mui/material/ClickAwayListener';

const IconActions = (props) => {
	const { actions = [], onAction } = props;

	const [anchorEl, setAnchorEl] = useState(null);
	const [target, setTarget] = useState(null);

	const handleClose = useCallback(() => {
		setAnchorEl(null);
		setTarget(null);
	}, []);

	const handleActionClick = useCallback(
		(e, action) => {
			if (!action.lines?.length) {
				if (onAction) onAction(action.id);
			} else {
				// Clickaway issue
				setTimeout(() => {
					setAnchorEl(e.target);
					setTarget(action);
				}, 0);
			}
		},
		[onAction],
	);

	const handleLineClick = useCallback(
		(line) => {
			if (onAction) onAction(line.id);
			setAnchorEl(null);
			setTarget(null);
		},
		[onAction],
	);

	return (
		<>
			{actions.length > 0 && (
				<Stack direction="row" flexWrap="wrap">
					{actions.map((action) => {
						return (
							<Button
								key={action.id}
								size="small"
								sx={{
									textWrap: 'nowrap',
									mr: 1,
									color: 'text.secondary',
									px: 1,
									py: 0.5,
									minWidth: 0,
								}}
								startIcon={action.icon}
								color="secondary"
								variant="text"
								onClick={(e) => handleActionClick(e, action)}
							>
								{action.label}
							</Button>
						);
					})}
				</Stack>
			)}
			{target && anchorEl && (
				<Popper id={target?.id} open anchorEl={anchorEl} placement="top-start">
					<ClickAwayListener onClickAway={handleClose}>
						<Paper elevation={2}>
							{target.lines.map((line) => {
								return (
									<Stack key={line.id}>
										<ListItemButton onClick={() => handleLineClick(line)}>
											<ListItemText primary={line.text} />
										</ListItemButton>
									</Stack>
								);
							})}
						</Paper>
					</ClickAwayListener>
				</Popper>
			)}
		</>
	);
};

IconActions.propTypes = {
	actions: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			label: PropTypes.string,
			icon: PropTypes.node,
			lines: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
					text: PropTypes.string,
				}),
			),
		}),
	),
	onAction: PropTypes.func,
};

export default IconActions;
